import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './errorLog'// error log
//import './mock' // simulation data

//import './icons' // icon
import './permission' // permission control

import * as filters from './filters' // 全局filter
import i18n from './lang' // Internationalization

Vue.use(Element, {
  size: 'medium', // set element-ui default size
  //i18n: (key, value) => i18n.t(key, value)
})


// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import 'normalize.css/normalize.css'//CSS resets
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.scss'

//查看大图
import imageViewer from './plugins/imageViewer'
Vue.use(imageViewer)

//引入ueditor编辑器
//import 'assets/UE/ueditor.all.min.js'
import '../static/UE/ueditor.config.js'
import '../static/UE/ueditor.all.js'
import '../static/UE/lang/zh-cn/zh-cn.js'
import '../static/UE/ueditor.parse.min.js'

import config from './config'
import {setSearchList,getSearchList,removeSearchList} from './utils/auth'

Object.defineProperties(Vue.prototype, {
  $baseUrl: {
    value: config.api
  },
  $uploadUrl: {
    value: {
      uploadImage:config.api+ config.uploadImageApi,
      uploadFile:config.api+ config.uploadFileApi,
    }
  },
  $successCode:{
    value:config.successCode
  },
  $local: {
    value: {setSearchList,getSearchList,removeSearchList}
  },
  //拼接图片地址
  $getImagesPath: {
    value(img){
      if (!img) return ''
      if (/^http/.test(img)) return img
      return config.imgPath + img
    }
  },
  $getUrlPath: {
    value(url){
      if (!url) return ''
      if (/^http/.test(url)) return url
      return config.api + url.substr(1)
    }
  },
  //富文本编辑的文字内容中对图片地址进行批量转换
  $articleRegImg: {
    value(contents){
      var regStr = new RegExp('src="*.?jbt/image/path', 'ig');
      var repStr = 'src="' + config.imgPath + 'jbt/image/path';
      return contents.replace(regStr, repStr);
    }
  },
  //判断权限
  hasPermissions: {
    value(permission){
      // return true;
      let permissionsList = store.getters.permission
      if (!permissionsList || !permissionsList.length) return true;
      if (permission) {
        if (typeof permission === 'object') {
          let flag = false
          for (let perms of permission) {
            flag = permissionsList.indexOf(perms) > -1
            if (flag) break;
          }
          return flag
        } else {
          return permissionsList.indexOf(permission) > -1
        }
      } else {
        return false
      }
    }
  }
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js